export const PRIVATE_EVENTS_SEO_DESCRIPTION =
  "Book private comedy and magic events in NYC with ComedyUO. Corporate entertainment, client dinners, member events, cocktail-hour magic, seated showcases, and turnkey production across New York City.";
